export const ADDON_WIFI_MESH_CODE = "GOMO_WIFI_MESH_6";
